export const localization = {
  en: {
    joinIn: 'Click here to start'
  },
  es: {
    joinIn: 'Haz clic para iniciar'
  },
  keyMapping: {
    joinIn: 'UFD_Appointment_Join_In_Label'
  }
}
